import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS = {
  250: '0xE8Aa025a25C8Bc26975B4e093f51b75bAa5391b4',
  4002: '0xa9788CDc2084557e6551797d28CCb4BE8001B0A6',
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
